import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=a0349d72&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0349d72')) {
      api.createRecord('a0349d72', component.options)
    } else {
      api.reload('a0349d72', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=a0349d72&", function () {
      api.rerender('a0349d72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4u3g1VRDfEo11/JS/offershelp.vue"
export default component.exports